import React from "react";

const ListSecretKeys = () => {
  return <div>Secret Keys list</div>;
};

export default ListSecretKeys;
